
import { GET_CONSUMER_DETAILS, GET_TRIAGE_CASES, GET_TRIAGE_DETAILS,GET_ADRRF_CASE, VOLUNTARY_ADRRF } from '../types'

const INITIAL_STATE = {
  allTriageCases: [],
  triageDetials: [],
  consumerDetails: {},
  getADRRFCaseInfo:{},

}

const caseTriageReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_TRIAGE_CASES:
      return {
        ...state,
        allTriageCases: payload.data
      }

    case GET_TRIAGE_DETAILS:
      return {
        ...state,
        triageDetials: payload?.data ?? payload
      }
    case GET_CONSUMER_DETAILS:
      return {
        ...state,
        consumerDetails: payload.data,
        getADRRFCaseInfo:{}
      }
    case GET_ADRRF_CASE :
      return {
        ...state,
        getADRRFCaseInfo:payload.data,
        consumerDetails:{}
      }
    case VOLUNTARY_ADRRF:
      return{
        ...state,
        voluntaryFormsData: payload
      }
    default:
      return state
  }
}

export default caseTriageReducer
